import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type UploadFloorLayoutOptions = {
  mutationConfig?: MutationConfig<typeof uploadFloorLayouts>;
};

type UploadDocumentType = {
  layouts: FileList;
  estateId: string;
};

const uploadFloorLayouts = ({ layouts, estateId }: UploadDocumentType) => {
  return extractData(api.estates({ id: estateId }).layouts.batch.post({ layouts }));
};

export const useUploadFloorLayouts = ({ mutationConfig }: UploadFloorLayoutOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: uploadFloorLayouts,
  });
};
